import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ListServices from './ListServices';
import CreateService from './CreateService';
import EditService from './EditService';

export default function ServiceFlowRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<ListServices />} />
      <Route path="new" element={<CreateService />} />
      <Route path=":serviceType/edit" element={<EditService />} />
      {/* fallback */}
      <Route path="*" element={<Navigate to="list" replace />} />
    </Routes>
  );
}
